import App from 'app/app.js';

var CLAIM = 'Claim';
var SIGN_IN_UP = 'Sign In_Up Pages';
var ACCOUNT = 'Account';
var PACKAGES = 'Packages';
var CUSTOM_PACKAGES = 'Custom Packages';
var ADD_ONS = 'Add Ons';
var SPECIAL_OFFERS = 'Bundle Deals';
var CART = 'Cart';
var PDF = 'Picture Day Finder';
var PROFILE = 'Profile';
var LANDING = 'Landing';
var CHECKOUT = 'Checkout';
var ERROR = 'Error';
var REWARDS = 'Rewards';
var PORTRAIT_LOOKS = 'portrait-looks';
var OFFERS = 'offers';
var PERSONALIZE = 'Personalize';
var STATUS = 'Status';

var SiteSectionsConstants = {
  '/': LANDING,
  '/safety': CLAIM,
  '/downloads': ERROR,
  '/pay-only': CLAIM,
  '/safety-receipt': CLAIM,
  '/portrait-store': CLAIM,
  '/safety-download': CLAIM,
  '/enhanced-pay-only': CLAIM,
  '/safety-confirmation': CLAIM,
  '/safety/:identifier': CLAIM,
  '/didError/:identifier': ERROR,
  '/dsskError/:identifier': ERROR,
  '/downloads/:identifier': ERROR,
  '/pictureDayId/:identifier': CLAIM,
  '/enhanced-pay-only/edit/:editIndex': ERROR,
  '/accessCredentials/:identifier/:accessCode': LANDING,
  '/explainer': SIGN_IN_UP,
  '/reset-password': ACCOUNT,
  '/login': ACCOUNT,
  '/switch-account': ACCOUNT,
  '/password-recovery': ACCOUNT,
  '/create-account': SIGN_IN_UP,
  '/password-recovery/guestAccount': ACCOUNT,
  '/password-recovery/setPasswordForGuest': ACCOUNT,
  '/myfamily-rewards-enrollment/:routeTo': REWARDS,
  '/enter-password': ACCOUNT,
  '/my-account/': ACCOUNT,
  '/order-history/': ACCOUNT,
  '/order-detail/:orderId': ACCOUNT,
  '/packages': PACKAGES,
  '/portrait-looks/:desc': PORTRAIT_LOOKS,
  '/package-detail/:skuCode': PACKAGES,
  '/package-detail/edit/:editIndex': PACKAGES,
  '/textPersonalizer/package/:skuCode': PERSONALIZE,
  '/textPersonalizer/edit/package/:skuCode/:editIndex': PERSONALIZE,
  '/cyop': PACKAGES,
  '/cyop/edit/:editIndex': PACKAGES,
  '/portrait-looks/:desc/:fromPage': PORTRAIT_LOOKS,
  '/textPersonalizer/cyop/:skuCode': PERSONALIZE,
  '/textPersonalizer/edit/cyop/:skuCode/:editIndex': PERSONALIZE,
  '/addon': ADD_ONS,
  '/addon-detail/:skuCode': ADD_ONS,
  '/suggestedProducts': ADD_ONS,
  '/addon-detail/edit/:editIndex': ADD_ONS,
  '/accessCredentials/:identifier/:accessCode/addon/:skuCode': ADD_ONS,
  '/textPersonalizer/addon/:skuCode': PERSONALIZE,
  '/textPersonalizer/edit/addon/:skuCode/:editIndex': PERSONALIZE,
  '/bundle-deals': OFFERS,
  '/textPersonalizer/edit/bundle/:skuCode/:editIndex': PERSONALIZE,
  '/textPersonalizer/bundle/:skuCode': PERSONALIZE,
  '/bundle-detail/edit/:editIndex': SPECIAL_OFFERS,
  '/bundle-detail/:skuCode': SPECIAL_OFFERS,
  '/shopping-cart': CART,
  '/order-receipt': CHECKOUT,
  '/review-order': CHECKOUT,
  '/billing-info': CHECKOUT,
  '/taxInfo': CHECKOUT,
  '/billing-info/:message': CHECKOUT,
  '/payment-info': CHECKOUT,
  '/findmypictureday': PDF,
  '/prepay-student-info': PROFILE,
  '/we-found-a-match': PROFILE,
  '/we-found-a-match:studentIdPath': PROFILE,
  '/event-list': PROFILE,
  '/picture-day': PROFILE,
  '/student-id-info': PROFILE,
  '/school-finder': PROFILE,
  '/order-status-lookup': STATUS,
  '/my-proofs': PROFILE,
  '/my-dashboard': PROFILE,
  '/i-dont-have-code': CLAIM
};

App.constant('SiteSectionsConstants', SiteSectionsConstants);
